import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import alert, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

export enum ToastTypes {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}

export const successObject = {
  icon: 'success',
  customClass: {
    confirmButton: 'alertButtonSuccess',
  },
  buttonsStyling: false,
};

export const alertPresets = {
  createImport: {
    title: 'Encrypted Data Detected!',
    text: "You are attempting to import a file that contains encrypted fields. Please ensure that all data is in plain text format (not encrypted or masked) before proceeding with the import. \n Do you wish to continue with the import?",
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Proceed',
    buttonsStyling: false,
    reverseButtons: true,
  },
  deleteApp: {
    title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: 'deleteAlertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
      input: 'swal-input-label'
    },
    input: 'text',
    inputLabel: 'Please type "delete application"\nin the text box below.',
    inputPlaceholder: '',
    inputAttributes: {
      maxlength: "19",
      autocapitalize: "off",
      autocorrect: "off"
    }
  },
  deleteRecords: {
    title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: 'deleteAlertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
      input: 'swal-input-label'
    },
    input: 'text',
    inputLabel: 'Please type "delete"\nin the text box below.',
    inputPlaceholder: '',
    inputAttributes: {
      maxlength: "19",
      autocapitalize: "off",
      autocorrect: "off"
    }
  },
  renameApp: {
    title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Update',
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: 'deleteAlertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
      input: 'swal-input-label'
    },
  },
  deniedDeleteApp: {
    icon: 'error',
    customClass: {
      confirmButton: 'alertButtonSuccess',
    },
    buttonsStyling: false,
  },
  delete: {
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes, delete it!',
    buttonsStyling: false,
    reverseButtons: true,
  },
  successDelete: {
    title: 'Deleted!',
    text: 'Your record has been deleted.',
    ...successObject,
  },
  saveSuccess: {
    title: 'Saved!',
    text: 'Your changes have been saved.',
    ...successObject,
  },
  importSyc: {
    title: 'Are you sure?',
    text: 'This option will remove data that is not in the import data. The sync means it is an exact match of import data.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes',
    reverseButtons: true,
    buttonsStyling: false,
  },
  notificationSave: {
    title: 'Are you sure?',
    text: 'This subscription will email the report to ALL USERS in the application.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes',
    reverseButtons: true,
    buttonsStyling: false,
  },
  importReload: {
    title: 'Are you sure?',
    text: 'This option will reload import.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes',
    buttonsStyling: false,
    reverseButtons: true,
  },
  purgeExecute: {
    title: 'Are you sure?',
    text: 'This option will execute purge.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes',
    buttonsStyling: false,
    reverseButtons: true,
  },
  sendEmail: {
    title: 'Send Email',
    text: 'Email will be sent to user for password recovery!',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes, send it!',
    buttonsStyling: false,
    reverseButtons: true,
  },
  loadAllData: {
    title: 'Load All Data',
    text: 'Loading all data could take a while. Continue?',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Continue',
    buttonsStyling: false,
    reverseButtons: true,
  },
  createForm:{
    title: 'Required Fields Missing',
    icon: 'warning',
    text: `The following required fields are missing:\n Please provide values for all non-nullable and unique fields to proceed.`,
    showCancelButton: true,
    showConfirmButton: false,
    customClass: {
      cancelButton: 'mr-3 alertButtonCancel',
    },
    buttonsStyling: false,
    reverseButtons: true,
  },
  modifyLookups: {
    title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, modify it!',
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
      input: 'swal-input-label'
    },
    input: 'text',
    inputLabel: 'Please type "modify"\nin the text box below.',
    inputPlaceholder: '',
    inputAttributes: {
      maxlength: "19",
      autocapitalize: "off",
      autocorrect: "off"
    }
  },
  editWorkflowTriggerConfirmation: {
    title: 'Are you sure you want to change the trigger type?',
    text: 'This change will update the existing automation and save immediately.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Confirm',
    buttonsStyling: false,
    reverseButtons: true,
  },
  deleteWebhookWithWorkflow: {
    title: 'Are you sure you want to delete this webhook?',
    text: 'This will also delete the corresponding workflow. If you would like to keep the workflow available for reference, edit and switch the workflow to Inactive.',
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes, Delete Both',
    cancelButtonText: 'Cancel',
    buttonsStyling: false,
    reverseButtons: true,
  },
};

export function getAccessibleSendEmailPreset(): any {
  return {
    title: '<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;padding:0;margin:-1px">Warning: </span>Send Email',
    html: `<p id="dialog-desc">Email will be sent to user for password recovery!</p>`,
    icon: 'warning',
    showCancelButton: true,
    customClass: {
      confirmButton: 'alertButtonSuccess',
      cancelButton: 'mr-3 alertButtonCancel',
    },
    confirmButtonText: 'Yes, send it!',
    cancelButtonText: 'Cancel',
    confirmButtonAriaLabel: 'Confirm send password reset email',
    cancelButtonAriaLabel: 'Cancel password reset email',
    buttonsStyling: false,
    reverseButtons: true,
    ariaDescribedby: 'dialog-desc',
    focusConfirm: false,
    focusCancel: false,

    willOpen: (popup: any) => {
      popup.setAttribute('role', 'alertdialog');
      const anchor = document.createElement('div');
      anchor.id = 'swal2-a11y-anchor';
      anchor.setAttribute('tabindex', '-1');
      anchor.setAttribute('aria-describedby', 'dialog-desc');
      anchor.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;padding:0;margin:-1px';
      popup.insertBefore(anchor, popup.firstChild);
      const actions = popup.querySelector('.swal2-actions');
      if (actions) { actions.setAttribute('inert', ''); }
    },
    didOpen: (popup: any) => {
      const anchor = popup.querySelector('#swal2-a11y-anchor');
      if (anchor) { anchor.focus(); } else { popup.focus(); }
      const actions = popup.querySelector('.swal2-actions');
      if (actions) { actions.removeAttribute('inert'); }
    }
  };
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private toastr: ToastrService) {}

  /**
   * Fire alert
   * @param alertObject
   */

  fire = (
    alertObject: SweetAlertOptions,
    extras: SweetAlertOptions = {}
  ): Promise<SweetAlertResult> =>{
    return alert.fire({ ...alertObject, ...extras });
  }

  /**
   * Toast
   */
  toast = (type: ToastTypes, title: string, message: string, options ?: {} ) => {
    this.toastr[type](message, title, options);
  };

  /**
   * Displays an error toast with smart message extraction.
   * Handles plain strings, Fluent Validation error objects, and generic objects.
   */
  toaster = (message: any): void => {
    let displayMessage = message;
    if (typeof message === 'object' && message !== null && message.errors) {
      const errorMessages = Object.values(message.errors)
        .reduce((acc: string[], val: any) => acc.concat(val), []);
      displayMessage = errorMessages.join('\n');
    }
    this.toast(
      ToastTypes.ERROR,
      'ERROR',
      displayMessage || 'An error occurred.'
    );
  };

  clear = () => {
    this.toastr.clear();
  }

    /**
   * Warning alert dialog matching the WarningDialogComponent styling
   * @param options - Configuration options for the warning dialog
   * @returns Promise that resolves to true if confirmed, false if cancelled
   */
  warningAlert = (options: {
    title: string;
    body: string;
    cancelText?: string;
    confirmText?: string;
  }): Promise<boolean> => {
    return alert.fire({
      titleText: options.title,
      html: `<p class="warning-swal__body">${this.escapeHtml(options.body)}</p>`,
      icon: 'warning',
      iconHtml: `
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.99992 1.33337L0.666584 14H15.3333L7.99992 1.33337ZM7.99992 12.6667C7.63325 12.6667 7.33325 12.3667 7.33325 12C7.33325 11.6334 7.63325 11.3334 7.99992 11.3334C8.36659 11.3334 8.66659 11.6334 8.66659 12C8.66659 12.3667 8.36659 12.6667 7.99992 12.6667ZM8.66659 10H7.33325V6.66671H8.66659V10Z" fill="currentColor"/>
        </svg>
      `,
      showCancelButton: true,
      cancelButtonText: options.cancelText || 'Cancel',
      confirmButtonText: options.confirmText || 'Confirm',
      customClass: {
        popup: 'warning-swal',
        title: 'warning-swal__title',
        htmlContainer: 'warning-swal__content',
        actions: 'warning-swal__actions',
        cancelButton: 'warning-swal__btn warning-swal__btn--cancel',
        confirmButton: 'warning-swal__btn warning-swal__btn--confirm',
        icon: 'warning-swal__icon'
      },
      buttonsStyling: false,
      focusCancel: true,
      focusConfirm: false,
      returnFocus: true,
      allowEscapeKey: true,
      allowEnterKey: true,
      showClass: {
        popup: 'swal2-show',
        backdrop: 'swal2-backdrop-show'
      },
      hideClass: {
        popup: 'swal2-hide',
        backdrop: 'swal2-backdrop-hide'
      },
      didOpen: (popup) => {
        // Explicitly focus the cancel button after modal opens
        const cancelButton = popup.querySelector('.warning-swal__btn--cancel') as HTMLElement;
        if (cancelButton) {
          // Use setTimeout to ensure DOM is ready and other focus traps are set
          setTimeout(() => {
            cancelButton.focus();
          }, 0);
        }
      }
    }).then((result) => {
      return result.isConfirmed;
    });
  }

    /**
   * Safely escape a string for insertion into HTML contexts.
   * This prevents HTML/JS injection when interpolating user-controlled values.
   */
  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;');
  }

    /**
   * Show delete table warning dialog
   * @param tableName - Name of the table to delete
   * @returns Promise that resolves to true if confirmed, false if cancelled
   */
  deleteTableWarning = (tableName: string): Promise<boolean> => {
    return this.warningAlert({
      title: 'Final Warning: Permanent Data Loss',
      body: `You are about to delete the table ${tableName}. This will immediately destroy all data contained within it.`,
      confirmText: 'Delete Table'
    });
  }
}




